import React, { useEffect, useRef, useState } from 'react'
import {
  Divider,
  FormHelperText,
  Grid,
  Paper,
  TextField,
  MenuItem,
  FormControl,
  Select,
  Radio,
  RadioGroup,
  FormControlLabel,
  useMediaQuery,
  useTheme,
  Box,
  Checkbox,
  InputAdornment,
  CircularProgress,
  IconButton,
  ClickAwayListener,
  Popper,
  FormLabel,
  Button
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import {
  colorWithOpacity,
  isEmpty,
  showToast,
  validateEmail,
  validateName,
  validateOTP,
  validatePassword,
  validatePhone
} from '../../utils/AppHelper'
import serverData from '../../api/ServerData'
import CustomModal from '../../commonComponents/CustomModal'
import { useNavigate } from 'react-router'
import {
  TextBold,
  TextMedium,
  TextRegular,
  TextSemiBold
} from '../../commonComponents/TextStyling'
import PhoneInput from '../../commonComponents/PhoneInput'
import appassets from '../../utils/appassets'
import AppButton from '../../commonComponents/AppButton'
import ReCAPTCHA from 'react-google-recaptcha'
import PasswordPopperComponent from '../../commonComponents/PasswordPopperComponent'
import { GoogleLogin } from '@react-oauth/google'

import { ENV } from '../../ENV'
import OTPInput from './OTPInput'
import { useDispatch } from 'react-redux'
import EditIcon from '@mui/icons-material/Edit'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { logoutUser } from '../../actions/loginActions'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import LooksOneIcon from '@mui/icons-material/LooksOne'
import LooksTwoIcon from '@mui/icons-material/LooksTwo'
import { setUserDetails } from '../../utils/LocalStorage'

const useStyles = makeStyles({
  input: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  }
})

export default function SignupForm (props) {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('md'))
  const classes = useStyles()
  const navigate = useNavigate()
  const recaptcha = useRef()

  const [showOTP, setShowOTP] = useState(false)
  const [showEmail, setShowEmail] = useState(true)
  const [showForm, setShowForm] = useState(false)

  const [termsChecked, setTermsChecked] = useState(true)

  const [zipCode, setZipCode] = useState('')

  const [firstname, setFirstname] = useState('')
  const [lastname, setLastname] = useState('')
  const [phone, setPhone] = useState('')
  const [recruitertype, setRecruitertype] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [othertext, setOtherText] = useState('')
  const [countrycode, setCountrycode] = useState('91')
  const [companyname, setCompanyname] = useState('')
  const [loading, setLoading] = useState(false)

  const [zipCodeLoading, setZipCodeLoading] = useState(false)

  const [activeForm, setActiveForm] = useState('basic')

  const [activeFormMatches, setActiveFormMatches] = useState('')

  const [basicFormDone, setBasicFormDone] = useState(false)

  const [addressLine1, setAddressLine1] = useState('')

  const [cityStatePopper, setCitystatePopper] = useState(false)
  const [openPopper, setOpenPopper] = useState(false)
  const anchorRef = useRef(null)

  const [formError, setFormError] = useState({})
  const [modal, setModal] = useState({
    open: false,
    title: '',
    message: '',
    onClose: null
  })

  const [country, setCountry] = useState('')
  const [countryId, setCountryId] = useState('')

  const [otp, setOtp] = useState('')
  const [countdown, setCountdown] = useState(59) // Countdown starts from 59 seconds
  const [timerActive, setTimerActive] = useState(false)

  const [companyFormOpen, setCompanyFormOpen] = useState(false)

  const dispatch = useDispatch()

  const [size, setSize] = useState('')
  const [websiteURL, setWebsiteURL] = useState('')

  const companySize = [
    { id: 1, value: '1-10', size: '1-10' },
    { id: 2, value: '11-50', size: '11-50' },
    { id: 3, value: '51-200', size: '51-200' },
    { id: 4, value: '200-500', size: '200-500' },
    { id: 5, value: '501-1000', size: '501-1000' },
    { id: 6, value: '1001-5000', size: '1001-5000' },
    { id: 7, value: '5001-10000', size: '5001-10000' },
    { id: 8, value: '110000+', size: '10000+' }
  ]

  useEffect(
    function () {
      verifyOTP(otp)
    },
    [otp]
  )

  useEffect(
    function () {
      if (showForm) {
        setActiveForm('basic')
      }
    },
    [showForm]
  )

  function getStateAndCityByZipcode (zipCode) {
    setZipCodeLoading(true)
    serverData.getStateAndCityByZipcodeUsers(
      { zipCode },
      result => {
        if (result.status) {
          setFormError({})
          let { city, state, country } = result.response
          setState(state)
          setCity(city)
          let countryObj = props.dropDownValues?.countries?.find(
            item => item.nicename === country
          )
          if (countryObj) {
            setCountry(countryObj.id)
          }
          setCitystatePopper(true)
          setOpenPopper(true)
        } else {
          setCitystatePopper(false)
          setOpenPopper(false)
          const error = {}
          error.zipCode = 'Please enter valid zip code.'
          setFormError(error)
        }
        setZipCodeLoading(false)
      },
      error => {
        setZipCodeLoading(false)

        if (error.status === 401) {
          console.log(error)
        }
      }
    )
  }

  const handleOtpSubmit = otpString => {
    setOtp(otpString)
  }

  const handleSubmitCompany = async event => {
    event.preventDefault()
    const error = {}

    if (isEmpty(companyname)) {
      error.companyname = 'Please enter company name.'
    }
    if (isEmpty(email)) {
      error.email = 'Please enter email.'
    }
    if (isEmpty(size)) {
      error.size = 'Please select size.'
    }
    if (isEmpty(websiteURL)) {
      error.websiteURL = 'Please enter website URL.'
    }
    if (isEmpty(addressLine1)) {
      error.addressLine1 = 'Please enter address line 1'
    }
    if (isEmpty(zipCode)) {
      error.zipCode = 'Please enter zip code.'
    }
    if (isEmpty(city)) {
      error.city = 'Please enter city'
    }
    if (isEmpty(state)) {
      error.state = 'Please select state'
    }
    if (isEmpty(country)) {
      error.country = 'Please select country'
    }

    setFormError(error)

    if (Object.keys(error).length === 0) {
      setLoading(true)
      const body = {
        companyname,
        size,
        websiteUrl: websiteURL,
        addressLine1,
        zipCode,
        city,
        state,
        email
      }

      await serverData.signupCompanyDetails(
        body,
        data => {
          if (data.status) {
            serverData.login({ email, password }, result => {
              if (result.status) {
                setUserDetails(result.response)
                navigate(
                  result.response.usertype === 'employer'
                    ? '/employer/accountcreated'
                    : '/recruiter/dashboard'
                )
              }
            })
            // navigate('/accountcreated')
            // setModal({
            //   open: true,
            //   title: 'Signup successful',
            //   message: data.message,
            //   onClose: () => {
            //     navigate('/employer/postnewj')
            //   }
            // })
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  console.log(countrycode)

  const handleSubmit = async event => {
    event.preventDefault()
    const error = {}

    if (isEmpty(firstname)) {
      error.firstname = 'First name cannot be empty'
    } else if (!validateName(firstname)) {
      error.firstname = 'Enter a valid name'
    }

    if (isEmpty(lastname)) {
      error.lastname = 'Last name cannot be empty'
    } else if (!validateName(lastname)) {
      error.lastname = 'Enter a valid name'
    }

    if (isEmpty(phone) || !validatePhone(phone)) {
      error.phone = 'Phone number must be 10 digits'
    }

    if (isEmpty(email) || !validateEmail(email)) {
      error.email = 'Invalid email'
    }

    if (isEmpty(password)) {
      error.password = 'Password cannot be empty'
    } else if (password.length < 8) {
      error.password = 'Password should be 8 characters long'
    } else if (!validatePassword(password)) {
      error.password =
        'Password should contain at least a letter, number, and special character'
    }

    const captchaValue = recaptcha.current.getValue()
    if (isEmpty(captchaValue)) {
      error.recaptcha = 'Please verify captcha'
    }

    setFormError(error)

    if (Object.keys(error).length === 0) {
      setLoading(true)
      const body = {
        usertype: props.name,
        firstname,
        lastname,
        countrycode,
        phone,
        email,
        password,
        captchaValue
      }

      await serverData.signup(
        body,
        data => {
          if (data.status) {
            if (data.response === 'recruiter') {
              setModal({
                open: true,
                title: 'Active you account',
                message: data.message,
                onClose: () => {
                  navigate('/login')
                }
              })
            } else {
              setBasicFormDone(true)
              setActiveForm('company')
              setActiveFormMatches('company')
              setShowForm(false)
              setCompanyFormOpen(true)
            }
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  const handleResendOTP = () => {
    setCountdown(59) // Reset countdown
    setTimerActive(true) // Restart the timer
    handleGetOPT(email)
  }

  const handleGetOPT = async event => {
    event.preventDefault()
    const error = {}

    if (isEmpty(email) || !validateEmail(email)) {
      error.email = 'Invalid email'
    }

    setFormError(error)

    if (Object.keys(error).length === 0) {
      setLoading(true)
      const body = { email }

      await serverData.getEmailOPT(
        body,
        data => {
          if (data.status) {
            setShowEmail(false)
            setShowOTP(true)
            setCountdown(59) // Reset countdown
            setTimerActive(true)
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  const verifyOTP = async otp => {
    // event.preventDefault()
    const error = {}

    if (isEmpty(otp) || !validateOTP(otp)) {
      error.otp = 'OTP must be 4 digits'
    }
    setFormError(error)

    if (Object.keys(error).length === 0) {
      setLoading(true)
      const body = { email, otp }

      await serverData.verifyOTP(
        body,
        data => {
          if (data.status) {
            setShowOTP(false)
            setShowForm(true)
            setTimeout(() => {
              setLoading(false)
              setShowEmail(false)
              setShowOTP(false)
              setCountdown(59)
              setTimerActive(false)
            }, 1000)
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  useEffect(() => {
    let timer
    if (timerActive && countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prev => prev - 1)
      }, 1000)
    } else if (countdown === 0) {
      setTimerActive(false)
    }
    return () => clearInterval(timer)
  }, [countdown, timerActive])

  const isButtonDisabled = !validateEmail(email) || !termsChecked

  return (
    <Grid
      container
      spacing={1}
      style={{
        backgroundImage: `url(./images/background-login.svg)`,
        padding: '0px',
        display: 'flex',
        backgroundSize: 'cover',
        justifyContent: 'center',
        backgroundRepeat: 'no-repeat',
        height: 'calc(100vh - 50px)',
        alignItems: 'center'
      }}
    >
      {!showForm && !companyFormOpen && !matches && (
        <Grid
          item
          xs={matches ? 12 : 6}
          container
          direction={'column'}
          justifyContent={'space-between'}
          style={{
            padding: matches
              ? '1rem'
              : props.name === 'recruiter'
              ? '0rem 0rem 0rem 8rem'
              : '0rem 0rem 0rem 13rem',
            height: 'auto',
            display: 'flex',
            justifyContent: props.name === 'recruiter' ? '' : 'center'
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div>
                <TextBold
                  style={{
                    fontSize: '40px',
                    lineHeight: '60px'
                  }}
                >
                  {props.name === 'recruiter' ? (
                    // 'Create your account for free and earn referrals in '
                    <>
                      <div>
                        <TextBold style={{ fontSize: '48px' }}>
                          Create your account for{' '}
                          <span
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: '48px'
                            }}
                          >
                            free
                          </span>{' '}
                        </TextBold>
                      </div>
                      <div>
                        <TextBold style={{ fontSize: '48px' }}>
                          and earn referrals{' '}
                          <span
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: '48px'
                            }}
                          >
                            quickly
                          </span>{' '}
                        </TextBold>
                      </div>
                    </>
                  ) : (
                    // 'Hiring top talent is now easier than ever!'
                    <>
                      <div>
                        <TextBold style={{ fontSize: '48px' }}>
                          Hire top talent{' '}
                          <span
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: '48px'
                            }}
                          >
                            faster
                          </span>{' '}
                        </TextBold>
                      </div>
                      <div>
                        <TextBold style={{ fontSize: '48px' }}>
                          post jobs for{' '}
                          <span
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: '48px'
                            }}
                          >
                            free
                          </span>
                        </TextBold>
                      </div>
                    </>
                  )}
                  {/* {props.name === 'recruiter' && (
                    <span style={{ color: theme.palette.primary.main }}>
                      3 steps
                    </span>
                  )} */}
                </TextBold>
              </div>
              <div style={{ marginTop: '12px' }}>
                <TextRegular
                  style={{
                    fontSize: '16px',
                    lineHeight: '28px',
                    color: `${theme.palette.text.disabled}`
                  }}
                >
                  {props.name === 'recruiter' ? (
                    // 'Follow these 3 simple steps and earn!!'
                    <TextRegular
                      style={{
                        fontSize: '16px',
                        lineHeight: '28px',
                        color: `${theme.palette.text.disabled}`
                      }}
                    >
                      Post jobs for free and connect with top talent – no
                      upfront costs, pay only for successful hires!
                    </TextRegular>
                  ) : (
                    // : `Create your own employer account and begin crowdsourcing talent on ${ENV.product_name} in 3 steps!`}
                    <TextRegular
                      style={{
                        fontSize: '16px',
                        lineHeight: '28px',
                        color: `${theme.palette.text.disabled}`
                      }}
                    >
                      Hire top talent <TextBold>40% faster</TextBold> with
                      expert recruiters – no upfront costs, pay only for
                      successful hires!
                    </TextRegular>
                  )}
                </TextRegular>
              </div>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid
        item
        xs={matches ? 12 : companyFormOpen || showForm ? 7 : 6}
        // md={8}
        style={{
          marginTop: '0rem',
          padding: !matches && '0rem 8rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
        {(showForm || companyFormOpen) && !matches && (
          <Box style={{ margin: '3rem 0px 1rem 0px' }}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby='demo-row-radio-buttons-group-label'
                name='row-radio-buttons-group'
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  width: '32rem'
                }}
                value={activeForm}
                onChange={e => {
                  setActiveForm(e.target.value)
                }}
              >
                {basicFormDone ? (
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Radio
                          disabled={basicFormDone}
                          icon={
                            <CheckCircleIcon
                              style={{ color: theme.palette.text.success }}
                            />
                          }
                        />
                      }
                      label={
                        <TextBold style={{ fontSize: '16px' }}>
                          Basic details
                        </TextBold>
                      }
                    />
                  </Grid>
                ) : (
                  <Grid item>
                    <FormControlLabel
                      value='basic'
                      control={<Radio />}
                      label={
                        <TextBold style={{ fontSize: '16px' }}>
                          Basic details
                        </TextBold>
                      }
                      onClick={() => {
                        if (!basicFormDone) {
                          setActiveForm('basic')
                          setShowForm(true)
                          setCompanyFormOpen(false)
                        }
                      }}
                    />
                  </Grid>
                )}
                <Grid
                  item
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '25%'
                  }}
                >
                  <Divider style={{ width: '100%' }} />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    value='company'
                    control={<Radio />}
                    label={
                      <TextBold style={{ fontSize: '16px' }}>
                        Company details
                      </TextBold>
                    }
                    onClick={() => {
                      setActiveForm('company')
                      setShowForm(false)
                      setCompanyFormOpen(true)
                    }}
                  />
                </Grid>
              </RadioGroup>
            </FormControl>
          </Box>
        )}

        <Paper
          elevation={1}
          style={{
            // border: !matches && `1px solid ${theme.palette.border.main}`, // old code I want dark border
            border: matches
              ? `1px solid ${theme.palette.border.main}`
              : props.name == 'employer' && (showEmail || showOTP)
              ? `1px solid ${theme.palette.text.primary}`
              : `1px solid ${theme.palette.border.main}`,
            borderRadius: !matches && '12px',
            padding: matches
              ? '0rem'
              : showForm || companyFormOpen
              ? '2rem 2rem'
              : '32px 24px',
            margin: matches ? '0px' : '1rem 0rem 2rem',
            width: matches
              ? '100%'
              : props.name === 'employer' && (showEmail || showOTP)
              ? '410px'
              : '580px',
            // : 'fit-content' // commented because of I want small width to basic and company detail form,
            minHeight: matches
              ? '100vh'
              : props.name === 'employer' && (showEmail || showOTP)
              ? '317px'
              : 'fit-content',
            height: 'fit-content'
          }}
        >
          {matches && (
            <>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', margin: '12px 24px' }}
              >
                {(showForm || companyFormOpen) && activeFormMatches === '' ? (
                  <div style={{ height: '24px' }}></div>
                ) : (
                  <>
                    <Grid item style={{ display: 'flex', flexGrow: 1 }}>
                      <IconButton
                        style={{ padding: 0 }}
                        onClick={() => {
                          if (activeFormMatches != '') {
                            setActiveFormMatches('')
                          } else {
                            props.setRecruiterSignup(null)
                          }
                        }}
                      >
                        <ArrowBackIcon />
                      </IconButton>
                    </Grid>

                    {activeFormMatches != '' && (
                      <Grid item>
                        <TextRegular
                          style={{ color: theme.palette.text.disabled }}
                        >
                          Step{' '}
                          {activeFormMatches === 'basic' ? (
                            <>1 of 2</>
                          ) : (
                            <>2 of 2</>
                          )}
                        </TextRegular>
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
              <Divider style={{ width: '100%' }} />
            </>
          )}

          {(showForm || companyFormOpen) &&
            matches &&
            activeFormMatches === '' && (
              <Grid container spacing={0} style={{ margin: '24px' }}>
                <Grid item xs={12}>
                  <TextBold style={{ fontSize: '16px' }}>
                    Create your account
                  </TextBold>
                </Grid>
                <Grid item xs={12}>
                  <TextRegular
                    style={{
                      fontSize: '16px',
                      color: theme.palette.text.disabled
                    }}
                  >
                    You need to complete these steps
                  </TextRegular>
                </Grid>

                <Grid item xs={10} style={{ margin: '3rem 0px 24px' }}>
                  <AppButton
                    onClick={() => {
                      if (!basicFormDone) {
                        setActiveForm('basic')
                        setActiveFormMatches('basic')
                        setShowForm(true)
                        setCompanyFormOpen(false)
                      }
                    }}
                    name={
                      <>
                        <LooksOneIcon
                          style={{
                            color: basicFormDone
                              ? theme.palette.text.blue
                              : theme.palette.text.disabled,
                            marginRight: '8px'
                          }}
                        />
                        <TextBold>Basic details</TextBold>
                      </>
                    }
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      backgroundColor: theme.palette.background.paper,
                      color: theme.palette.text.primary,
                      padding: '12px',
                      borderRadius: '12px'
                    }}
                  />
                </Grid>

                <Grid item xs={10} style={{}}>
                  <AppButton
                    onClick={() => {
                      setActiveForm('company')
                      setActiveFormMatches('company')
                      setShowForm(false)
                      setCompanyFormOpen(true)
                    }}
                    name={
                      <>
                        <LooksTwoIcon
                          style={{
                            color: theme.palette.text.disabled,
                            marginRight: '8px'
                          }}
                        />
                        <TextBold>Company details</TextBold>
                      </>
                    }
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      backgroundColor: theme.palette.background.paper,
                      color: theme.palette.text.primary,
                      padding: '12px',
                      borderRadius: '12px'
                    }}
                  />
                </Grid>
              </Grid>
            )}

          <Grid
            container
            spacing={matches ? 0 : 2}
            style={{ padding: matches && '24px' }}
          >
            {!showForm && !companyFormOpen && props.name === 'employer' && (
              <Grid item xs={12} style={{ paddingBottom: '0px' }}>
                <TextBold style={{ fontSize: matches ? '18px' : '20px' }}>
                  {showEmail && <>Continue with email</>}
                  {showOTP && (
                    <>
                      Enter the OTP
                      {/* sent to this email {email}{' '} // not use in new UI  */}
                      {/* <IconButton
                        onClick={() => {
                          setShowEmail(true)
                          setShowOTP(false)
                        }}
                        style={{ padding: '0px 4px' }}
                      >
                        <EditIcon />
                      </IconButton> */}
                    </>
                  )}
                </TextBold>
              </Grid>
            )}

            {showEmail && props.name === 'employer' && (
              <>
                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    // margin='normal'
                    error={formError.email}
                  >
                    <TextSemiBold
                      style={{
                        margin: '20px 0px 8px',
                        color: theme.palette.text.secondary,
                        fontSize: '16px'
                      }}
                    >
                      Email id
                    </TextSemiBold>
                    <TextField
                      // size='small'
                      id='email'
                      // label='Email Address'
                      placeholder='Enter email'
                      required
                      variant='outlined'
                      fullWidth
                      name='email'
                      value={email}
                      onChange={e => {
                        var { value } = e.target
                        if (value.length < 50) {
                          setEmail(value)
                        }
                      }}
                      error={formError.email}
                      helperText={formError.email}
                    />
                    {/* {!formError.email && (
                      <TextRegular
                        style={{
                          fontSize: '12px',
                          color: theme.palette.text.disabled
                        }}
                      >
                        Check your email for the OTP.
                      </TextRegular>
                    )} */}
                  </FormControl>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ padding: matches ? '16px 0px' : '4px 0px 8px 16px' }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size='small'
                        checked={termsChecked}
                        style={{ color: theme.palette.text.blue }}
                        onChange={e => {
                          setTermsChecked(e.target.checked)
                        }}
                      />
                    }
                    label={
                      <TextRegular style={{ fontSize: '12px' }}>
                        I agree to the{' '}
                        <span
                          onClick={() =>
                            window.open(`${ENV.terms_conditions}`, '__blank')
                          }
                          style={{
                            color: theme.palette.text.blue,
                            cursor: 'pointer'
                          }}
                        >
                          Terms of Use
                        </span>{' '}
                        and{' '}
                        <span
                          onClick={() =>
                            window.open(`${ENV.privacy_policy}`, '__blank')
                          }
                          style={{
                            color: theme.palette.text.blue,
                            cursor: 'pointer'
                          }}
                        >
                          Privacy Policy
                        </span>
                      </TextRegular>
                    }
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ padding: !matches && '0px 0px 0px 16px' }}
                >
                  <AppButton
                    variant='contained'
                    name='Send OTP'
                    onClick={e => {
                      handleGetOPT(e)
                      // navigate('/accountcreated')
                      // setShowForm(true)
                    }}
                    disabled={isButtonDisabled}
                    loading={loading}
                    style={{
                      textTransform: 'none',
                      margin: '8px 0px'
                    }}
                  />
                </Grid>
              </>
            )}

            {showOTP && (
              <>
                <Grid item xs={12} style={{ margin: '1rem 0rem 0' }}>
                  <FormControl fullWidth margin='normal'>
                    {/* <OTPInput length={4} onOtpSubmit={handleOtpSubmit} /> */}
                    <OTPInput matches={matches} onSubmit={handleOtpSubmit} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextRegular
                    style={{
                      fontSize: '16px',
                      color: theme.palette.text.disabled
                    }}
                  >
                    Didn't receive it?
                  </TextRegular>
                  {countdown === 0 ? (
                    <AppButton
                      variant='text'
                      name='Resend OTP'
                      onClick={handleResendOTP}
                      disabled={false}
                      loading={loading}
                      style={{
                        textTransform: 'none',
                        // color: theme.palette.primary.main,
                        fontSize: '16px',
                        width: 'fit-content',
                        fontWeight: 'bold'
                      }}
                    />
                  ) : (
                    <TextRegular
                      style={{
                        fontSize: '16px',
                        color: theme.palette.text.disabled
                      }}
                    >
                      {' '}
                      Resend in{' '}
                      <span style={{ color: theme.palette.primary.main }}>
                        00:{countdown}
                      </span>
                    </TextRegular>
                  )}
                </Grid>
              </>
            )}

            {(showForm || props.name === 'recruiter' || companyFormOpen) && (
              <>
                {((matches && activeFormMatches != '') ||
                  props.name === 'recruiter' ||
                  !matches) && (
                  <>
                    {showForm && !companyFormOpen && (
                      <>
                        {activeFormMatches === 'basic' ? (
                          <TextBold
                            style={{ fontSize: '20px', marginBottom: '1rem' }}
                          >
                            Basic details
                          </TextBold>
                        ) : (
                          <>
                            <Grid
                              item
                              xs={12}
                              style={{
                                display: 'flex',
                                justifyContent: 'center'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: colorWithOpacity(
                                    theme.palette.primary.main,
                                    0.1
                                  ),
                                  borderRadius: '16px',
                                  padding: '8px 11px'
                                }}
                              >
                                <img
                                  src={`${appassets.basicDetails}`}
                                  alt='suitcase'
                                  width='50px'
                                />
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                padding: '1rem'
                              }}
                            >
                              <Grid item xs={12} textAlign={'center'}>
                                <TextRegular
                                  style={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '16px'
                                  }}
                                >
                                  We need this details to identify and create
                                  your account
                                </TextRegular>
                              </Grid>
                            </Grid>
                          </>
                        )}

                        <Grid
                          item
                          xs={12}
                          style={{ padding: matches && '12px 0px' }}
                        >
                          <TextRegular style={{ fontSize: '16px' }}>
                            Email:{' '}
                          </TextRegular>
                          <TextBold style={{ fontSize: '16px' }}>
                            {email}
                          </TextBold>
                        </Grid>
                      </>
                    )}

                    {companyFormOpen && !showForm && (
                      <>
                        {activeFormMatches === 'company' ? (
                          <TextBold
                            style={{ fontSize: '20px', marginBottom: '1rem' }}
                          >
                            Company details
                          </TextBold>
                        ) : (
                          <>
                            <Grid
                              item
                              xs={12}
                              style={{
                                display: 'flex',
                                justifyContent: 'center'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: colorWithOpacity(
                                    theme.palette.primary.main,
                                    0.1
                                  ),
                                  borderRadius: '16px',
                                  padding: '8px 11px'
                                }}
                              >
                                <img
                                  src={`${appassets.companyDetails}`}
                                  alt='companyDetails'
                                  style={{ marginRight: '8px', width: '50px' }}
                                />
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                padding: '1rem 0rem'
                              }}
                            >
                              <Grid item xs={12} textAlign={'center'}>
                                <TextRegular
                                  style={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '14px'
                                  }}
                                >
                                  We use this information to know about the
                                  company you're hiring for and to generate an
                                  invoice
                                </TextRegular>
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </>
                    )}

                    {(showForm || props.name === 'recruiter') && (
                      <>
                        <Grid item xs={12} md={6}>
                          <FormControl
                            fullWidth
                            // margin='normal'
                            error={formError.firstname}
                          >
                            <TextSemiBold
                              style={{
                                margin: '0px 0px 5px',
                                color: theme.palette.text.secondary,
                                fontSize: '14px'
                              }}
                            >
                              Full Name
                            </TextSemiBold>
                            <TextField
                              id='First Name'
                              required
                              // label='First Name'
                              placeholder='Enter full name'
                              variant='outlined'
                              name='firstname'
                              value={firstname}
                              size='small'
                              onChange={event => {
                                var { value } = event.target
                                if (value.length < 30) {
                                  setFirstname(
                                    value
                                      .replace(' ', '')
                                      .replace(/[^a-zA-z]/g, '')
                                  )
                                }
                              }}
                              error={formError.firstname}
                              helperText={formError.firstname}
                            />
                          </FormControl>
                        </Grid>

                        {/* Last name commented by palalvi beause we use full name - need to change in backend */}
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth error={formError.lastname}>
                            <TextSemiBold
                              style={{
                                margin: '00px 0px 5px',
                                color: theme.palette.text.secondary,
                                fontSize: '14px'
                              }}
                            >
                              Last Name
                            </TextSemiBold>
                            <TextField
                              id='Last Name'
                              required
                              // label='Last Name'
                              placeholder='Enter last name'
                              variant='outlined'
                              fullWidth
                              name='lastname'
                              size='small'
                              value={lastname}
                              onChange={e => {
                                var { value } = e.target
                                if (value.length < 30) {
                                  setLastname(
                                    value
                                      .replace(' ', '')
                                      .replace(/[^a-zA-z]/g, '')
                                  )
                                }
                              }}
                              error={formError.lastname}
                              helperText={formError.lastname}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <Grid item xs={12} style={{ margin: '0px 0px 5px' }}>
                            <TextSemiBold
                              style={{
                                color: theme.palette.text.secondary,
                                fontSize: '14px'
                              }}
                            >
                              Mobile number
                            </TextSemiBold>
                          </Grid>
                          <Grid container>
                            <Grid item xs={2.3}>
                              <FormControl fullWidth error={formError.country}>
                                <Select
                                  id='country'
                                  size='small'
                                  value={countrycode} // This will now store the phonecode (e.g., "91")
                                  onChange={event => {
                                    const selectedPhoneCode = event.target.value // This will be the phonecode (e.g., "91")
                                    setCountrycode(selectedPhoneCode) // Set the phonecode directly in the state
                                  }}
                                  renderValue={selectedPhoneCode => {
                                    // Display the selected phonecode with a '+' sign
                                    return selectedPhoneCode
                                      ? `+${selectedPhoneCode}`
                                      : ''
                                  }}
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      borderRight: 'none',
                                      borderTopRightRadius: 0,
                                      borderBottomRightRadius: 0
                                    }
                                  }}
                                >
                                  {props?.dropDownValues?.countries?.map(
                                    item => (
                                      <MenuItem
                                        required
                                        key={item.iso}
                                        value={item.phonecode}
                                      >
                                        {item.nicename}{' '}
                                        <TextRegular
                                          style={{
                                            color: theme.palette.text.disabled,
                                            marginLeft: 8
                                          }}
                                        >
                                          (+{item.phonecode})
                                        </TextRegular>
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                                <FormHelperText>
                                  {formError.country}
                                </FormHelperText>
                              </FormControl>
                            </Grid>

                            <Grid item xs={9.7} style={{ paddingLeft: 0 }}>
                              <FormControl fullWidth error={formError.phone}>
                                <PhoneInput
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      '& fieldset': {
                                        borderLeft: 'none', // Hide right border
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0
                                      }
                                    }
                                  }}
                                  variant='outlined'
                                  fullWidth
                                  size='small'
                                  name='phone'
                                  value={phone}
                                  onChange={e => {
                                    const input = e.target.value.replace(
                                      /\D/g,
                                      ''
                                    ) // Allow only numbers
                                    if (input.length <= 10) {
                                      setPhone(input) // Update the raw phone number value
                                    }
                                  }} // Use the custom handler
                                  error={formError.phone}
                                  helperText={
                                    formError.phone
                                      ? 'Invalid phone number'
                                      : ''
                                  }
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>

                        {props.name === 'recruiter' && (
                          <Grid item xs={12}>
                            <FormControl
                              fullWidth
                              // margin='normal'
                              error={formError.email}
                            >
                              <TextSemiBold
                                style={{
                                  margin: '0px 0px 5px',
                                  color: theme.palette.text.secondary,
                                  fontSize: '14px'
                                }}
                              >
                                Email id
                              </TextSemiBold>
                              <TextField
                                size='small'
                                id='email'
                                // label='Email Address'
                                placeholder='Enter email'
                                required
                                variant='outlined'
                                fullWidth
                                name='email'
                                value={email}
                                onChange={e => {
                                  var { value } = e.target
                                  if (value.length < 50) {
                                    setEmail(value)
                                  }
                                }}
                                error={formError.email}
                                helperText={formError.email}
                              />
                              {!formError.email && (
                                <TextRegular
                                  style={{
                                    fontSize: '12px',
                                    color: theme.palette.text.disabled
                                  }}
                                >
                                  Check your email for the OTP.
                                </TextRegular>
                              )}
                            </FormControl>
                          </Grid>
                        )}

                        <Grid item xs={12}>
                          <PasswordPopperComponent
                            password={password}
                            setPassword={setPassword}
                            formError={formError.password}
                            isPopper={true}
                            title={'Create Password'}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl
                            fullWidth
                            margin='normal'
                            error={formError.recaptcha}
                          >
                            <Box
                              sx={{
                                transform: 'scale(0.9)',
                                transformOrigin: '0 0',
                                width: '100%'
                              }}
                            >
                              <ReCAPTCHA
                                ref={recaptcha}
                                sitekey={ENV.keys.google_recaptcha_site_key}
                              />
                            </Box>
                            <FormHelperText>
                              {formError.recaptcha}
                            </FormHelperText>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <AppButton
                            variant='contained'
                            name={
                              props.name === 'recruiter'
                                ? 'Sign up'
                                : 'Continue'
                            }
                            onClick={handleSubmit}
                            disabled={false}
                            loading={loading}
                            style={{
                              textTransform: 'none',
                              padding: '9px',
                              fontSize: '16px',
                              borderRadius: '8px'
                            }}
                          />
                        </Grid>
                      </>
                    )}

                    {companyFormOpen && !showForm && (
                      <>
                        <Grid item xs={12}>
                          <FormControl
                            fullWidth
                            // margin='normal'
                            error={formError.companyname}
                          >
                            <TextSemiBold
                              style={{
                                margin: '0px 0px 5px',
                                color: theme.palette.text.secondary,
                                fontSize: '14px'
                              }}
                            >
                              Company
                            </TextSemiBold>
                            <TextField
                              id='Company Name'
                              required
                              size='small'
                              // label='Company Name'
                              placeholder='Enter company name'
                              variant='outlined'
                              fullWidth
                              name='companyname'
                              value={companyname}
                              onChange={e => {
                                var { value } = e.target
                                if (value.length < 100) {
                                  setCompanyname(value)
                                }
                              }}
                              error={formError.companyname}
                              helperText={formError.companyname}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl fullWidth error={formError.size}>
                            <TextSemiBold
                              style={{
                                margin: '0px 0px 5px',
                                color: theme.palette.text.secondary,
                                fontSize: '14px'
                              }}
                            >
                              No. of employees
                            </TextSemiBold>

                            <Select
                              required
                              id='size'
                              size='small'
                              value={size}
                              onChange={event => setSize(event.target.value)}
                              displayEmpty
                              renderValue={size =>
                                size ? size : 'Select range'
                              }
                            >
                              {companySize?.map(item => (
                                <MenuItem required value={item.value}>
                                  {item.size}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText>{formError.size}</FormHelperText>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl fullWidth error={formError.websiteURL}>
                            <TextSemiBold
                              style={{
                                margin: '0px 0px 5px',
                                color: theme.palette.text.secondary,
                                fontSize: '14px'
                              }}
                            >
                              Website
                            </TextSemiBold>

                            <TextField
                              placeholder='Enter website URL'
                              required
                              fullWidth
                              size='small'
                              value={websiteURL}
                              error={formError.websiteURL}
                              helperText={formError.websiteURL}
                              onChange={e => {
                                var { value } = e.target
                                if (value.length < 50) {
                                  setWebsiteURL(e.target.value)
                                }
                              }}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl fullWidth error={formError.zipCode}>
                            <TextSemiBold
                              style={{
                                margin: '0px 0px 5px',
                                color: theme.palette.text.secondary,
                                fontSize: '14px'
                              }}
                            >
                              Pincode
                            </TextSemiBold>

                            <TextField
                              placeholder='Enter company pincode'
                              required
                              fullWidth
                              size='small'
                              value={zipCode}
                              error={formError.zipCode}
                              helperText={formError.zipCode}
                              onChange={e => {
                                const input = e.target.value.replace(/\D/g, '')
                                if (input.length < 12) {
                                  setZipCode(input)
                                  if (input.length > 3) {
                                    getStateAndCityByZipcode(input)
                                  }
                                }
                              }}
                              inputRef={anchorRef}
                              // onBlur={() => {
                              //   if (zipCode.length > 3) {
                              //     getStateAndCityByZipcode()
                              //   }
                              // }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position='end'>
                                    {zipCodeLoading && (
                                      <CircularProgress size={24} />
                                    )}
                                  </InputAdornment>
                                )
                              }}
                            />
                            {cityStatePopper && (
                              <Popper
                                open={openPopper}
                                anchorEl={anchorRef.current}
                                placement='bottom-start'
                              >
                                <ClickAwayListener
                                  onClickAway={event => {
                                    if (
                                      !anchorRef.current.contains(event.target)
                                    ) {
                                      setOpenPopper(false)
                                    }
                                  }}
                                >
                                  <Paper
                                    sx={{
                                      padding: '16px',
                                      width: '100%'
                                    }}
                                  >
                                    <Grid container>
                                      <Grid item xs={12}>
                                        <TextMedium
                                          style={{
                                            color: theme.palette.text.blue,
                                            fontSize: '18px'
                                          }}
                                        >
                                          {zipCode}
                                        </TextMedium>
                                      </Grid>
                                      <Grid item xs={12}>
                                        <TextRegular
                                          style={{
                                            fontSize: '16px',
                                            margin: '8px 0px'
                                          }}
                                        >
                                          {city}, {state}
                                        </TextRegular>
                                      </Grid>
                                    </Grid>
                                  </Paper>
                                </ClickAwayListener>
                              </Popper>
                            )}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl fullWidth error={formError.addressLine1}>
                            <TextSemiBold
                              style={{
                                margin: '0px 0px 5px',
                                color: theme.palette.text.secondary,
                                fontSize: '14px'
                              }}
                            >
                              Company address
                            </TextSemiBold>

                            <TextField
                              placeholder='Enter company address'
                              multiline
                              rows={3}
                              required
                              size='small'
                              fullWidth
                              value={addressLine1}
                              error={formError.addressLine1}
                              helperText={formError.addressLine1}
                              onChange={e => {
                                var { value } = e.target
                                if (value.length < 100) {
                                  setAddressLine1(e.target.value)
                                }
                              }}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <AppButton
                            variant='contained'
                            name='Sign up'
                            onClick={handleSubmitCompany}
                            disabled={false}
                            loading={loading}
                            style={{
                              textTransform: 'none',
                              marginTop: '1.5rem',
                              padding: '12px',
                              fontSize: '16px',
                              borderRadius: '8px'
                            }}
                          />
                        </Grid>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </Grid>
        </Paper>
      </Grid>

      <CustomModal data={modal} matches={matches} />
    </Grid>
  )
}
